import Button from "@/components/buttons";
import Link from "next/link";
import TextComponent from "./TextComponent";

interface ConfirmationContentProps {
  email: string;
}

// Renamed from ConfirmationPage to ConfirmationContent
export function ConfirmationContent({ email }: ConfirmationContentProps) {
  return (
    <div className="font-['Poppins']">
      <TextComponent
        type="h2"
        className="text-2xl font-semibold text-indigo-950"
      >
        Thank you for your order
      </TextComponent>
      <div className="mt-8 space-y-6 text-base text-slate-600">
        <TextComponent type="body">
          You are all set up to access the Engine! An email confirmation has
          been sent to{" "}
          <span className="font-medium text-blue-500">{email}</span>.
        </TextComponent>
        <TextComponent type="body">
          You now have access to a powerful dashboard designed to optimize your
          email marketing efforts and help you arrange your metrics effortlessly
          for immediate insights. Start exploring your customizable metrics,
          save your favorite layouts, and create comprehensive PDF reports with
          ease. If you have any questions or need assistance, our support team
          is here to help.
        </TextComponent>
        <TextComponent type="body">Start your engine!</TextComponent>
      </div>
      <div className="mt-12">
        <Link href="/dashboard">
          <Button className="h-10 w-[253px]">
            <TextComponent type="button">Dashboard</TextComponent>
          </Button>
        </Link>
      </div>
    </div>
  );
}

export const ConfirmationPage = ConfirmationContent;
